/**
 * Build Livestream Functionality.
 * By default, if there is a countdown timer, the video-embed component will be hidden.
 * Once the countdown timer ends, the video-embed component will be shown.
 *
 * @returns void
 */
const buildLivestream = () => {
	const livestream = document.querySelector('[data-livestream]')
	if (!livestream) { return }

	const countdown = livestream.querySelector('countdown-timer')
	const videoEmbed = livestream.querySelector('video-mask')
	if (!countdown && !videoEmbed) { return }

	let countdownActive = !!countdown ?? false
	if (countdownActive) {
		if (videoEmbed) {
			videoEmbed.inert = true
		}
		countdown.addEventListener('timer-complete', () => {
			setTimeout(() => {
				countdownActive = false
				livestream.dataset.livestream = 'video'
				videoEmbed.inert = false
			}, 5000)
		}, { once: true })

		return
	}

	return

}

export { buildLivestream }
